module.exports = __webpack_public_path__ + "static/media/brochure.f39bddc6.pdf";